module.exports = __webpack_public_path__ + "static/media/const-prot-manual.f44ffa2c.pdf";